import { DateTime } from "luxon";
export const HOURS_ZONE = "America/New_York";
const anchor = DateTime.fromISO("2026-10-26", {zone:HOURS_ZONE});
export function hoursDate(value) {
  const date = DateTime.fromISO(value || "", {zone:HOURS_ZONE});
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !date.isValid) throw new Error("Enter a valid work date.");
  return date;
}
export function hoursPeriod(value) {
  const date = hoursDate(value);
  const start = anchor.plus({days:Math.floor(date.diff(anchor,"days").days / 14) * 14});
  return {start:start.toISODate(),end:start.plus({days:13}).toISODate()};
}
export function durationMinutes(hours, minutes) {
  if (!/^\d+$/.test(String(hours)) || !/^\d+$/.test(String(minutes))) throw new Error("Enter whole hours and minutes.");
  const total = Number(hours)*60 + Number(minutes);
  if (Number(minutes)>59 || !Number.isSafeInteger(total) || total<1 || total>1440) throw new Error("Enter a duration between 1 minute and 24 hours (minutes 0-59).");
  return total;
}
export const formatHours = minutes => `${Math.floor(minutes/60)}h ${minutes%60}m`;
export function hoursQueryConstraints(uid, superadmin, employee, period, where) {
  const filters = [where("workDate",">=",period.start),where("workDate","<=",period.end)];
  if (!superadmin || employee) filters.unshift(where("ownerUid","==",superadmin ? employee : uid));
  return filters;
}

export function clockMinutes(value) {
  if (!/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(value || "")) throw new Error("Choose time in and time out.");
  const [hours,minutes] = value.split(":").map(Number);
  return hours*60+minutes;
}
export function shiftMinutes(timeIn,timeOut,endsNextDay=false) {
  const total = clockMinutes(timeOut)-clockMinutes(timeIn)+(endsNextDay ? 1440 : 0);
  if(total<=0 || total>1440) throw new Error("Time out must follow time in. For an overnight shift, select next day (maximum 24 hours).");
  return total;
}
export const clockValue = minutes => String(Math.floor(minutes/60)).padStart(2,"0")+":"+String(minutes%60).padStart(2,"0");
export function hoursPeriodDays(date) {
  const start = hoursDate(hoursPeriod(date).start);
  return Array.from({length:14},(_,index)=>start.plus({days:index}).toISODate());
}
